import { BasketballEventStatusId } from '@collector/sportsapi-client-legacy'

import { PitchBlockedEventStatus } from '../../configuration'

export const pitchBlockedEventStatus: PitchBlockedEventStatus<BasketballEventStatusId> =
  new Set([
    BasketballEventStatusId.Abandoned,
    BasketballEventStatusId.Cancelled,
    BasketballEventStatusId.NotStarted,
    BasketballEventStatusId.StartDelayed,
    BasketballEventStatusId.Postponed,
    BasketballEventStatusId.Interrupted,
    BasketballEventStatusId.ToFinish,
    BasketballEventStatusId.FinishedAwardedWin,

    BasketballEventStatusId.BreakAfterFirstHalf,
    BasketballEventStatusId.BreakAfterFirstQuarter,
    BasketballEventStatusId.BreakAfterSecondQuarter,
    BasketballEventStatusId.BreakAfterThirdQuarter,
    BasketballEventStatusId.WaitingForOvertime,
    BasketballEventStatusId.BreakAfterFirstOvertime,
    BasketballEventStatusId.BreakAfterSecondOvertime,
    BasketballEventStatusId.BreakAfterThirdOvertime,
    BasketballEventStatusId.BreakAfterFourthOvertime,
    BasketballEventStatusId.FinishedRegularTime,
    BasketballEventStatusId.FinishedAfterOvertime,
  ])
